import React, {useState, useRef, useEffect} from "react"
import {useTranslation} from "react-i18next"
import {ReactComponent as RightArrow} from "../../icon/right-arrow.svg"
import {ReactComponent as LeftArrow} from "../../icon/left-arrow.svg"
import Theme from "../../library/Theme"
import Spinner from "../common/Spinner"

interface AiEffectToolbarProps {
  theme: Theme
  remainingRegenerations: number
  isProcessing: boolean
  onRegenerate: () => void
  imageUrls: string[]
  selectedIndex: number
  onSelect: (index: number) => void
}

export default function AiEffectToolbar({ theme, remainingRegenerations, isProcessing, onRegenerate, imageUrls, selectedIndex, onSelect }: AiEffectToolbarProps) {
  const { t } = useTranslation()
  const [showControls, setShowControls] = useState(true)
  const [enableLeftControl, setEnableLeftControl] = useState(false)
  const [enableRightControl, setEnableRightControl] = useState(false)
  const toolbarRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    updateControls()
  })

  const scroll = (x: number) => {
    if (!toolbarRef.current) return
    toolbarRef.current.scrollLeft += x
  }

  const updateControls = () => {
    const toolbar = toolbarRef.current
    if (!toolbar) return

    setEnableLeftControl(toolbar.scrollLeft > 0)
    setEnableRightControl(toolbar.scrollLeft + toolbar.clientWidth < toolbar.scrollWidth)
    setShowControls(toolbar.clientWidth < toolbar.scrollWidth)
  }

  const scrollAmount = toolbarRef.current ? toolbarRef.current.clientWidth / 2 : 100

  return (
    <div style={{display: "flex", flexDirection: "column", alignItems: "center", paddingBottom: 8}}>
      <div className="toolbarContainer">
        {showControls &&
          <div className={"controlButton" + (enableLeftControl ? "" : " disabled")} style={theme.buttonStyle} onClick={() => scroll(-scrollAmount)}>
            <LeftArrow style={theme.svgStyle} />
          </div>
        }
        <div ref={toolbarRef} className="toolbar" onScroll={updateControls}>
          {imageUrls.map((url, index) =>
            <img
              crossOrigin="anonymous"
              className="toolbarItem"
              key={index}
              src={url}
              alt={"AI Effect " + (index + 1)}
              style={index === selectedIndex ? theme.toolbarSelectedImageStyle : {}}
              onLoad={updateControls}
              onClick={() => onSelect(index)}
            />
          )}
        </div>
        {showControls &&
          <div className={"controlButton" + (enableRightControl ? "" : " disabled")} style={theme.buttonStyle} onClick={() => scroll(scrollAmount)}>
            <RightArrow style={theme.svgStyle} />
          </div>
        }
      </div>
      {isProcessing ? (
        <div style={{transform: "scale(0.5)"}}><Spinner color={theme.textStyle.color} /></div>
      ) : (
        remainingRegenerations >= 1 &&
          <button
            style={theme.buttonStyle}
            onClick={onRegenerate}
          >
            {t("edit.aiEffect.regenerate")} ({remainingRegenerations})
          </button>
      )}
    </div>
  )
}
